import { Container, Row } from "react-bootstrap";

const datee = new Date().getFullYear();

const Footer = () => {
  return (
    <Row className='bg-light  mt-3'>
      <p className='text-center'>
        (c){datee} BeaconSMS v1.0, All rights reserved
      </p>
    </Row>
  );
};

export default Footer;
